export default "__VITE_ASSET__BUMXVsKe__"